export default {
  getReservationDetail(state: any): any {
    return state.reservationInfo;
  },
};
